import {
  arrayBuilderYesNoSchema,
  arrayBuilderYesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { officialsArrayOptions } from '../helpers';

const hasOfficials = formData =>
  Array.isArray(formData?.officials) && formData.officials.length > 0;

/**
 * "Officials and faculty information" (0 items) is informational only — no yes/no.
 * The add-another question appears once at least one official exists (see `hideIf`).
 */
const officialsSummaryYesNo = arrayBuilderYesNoUI(
  officialsArrayOptions,
  {
    title:
      'Do you have a faculty member, school official, or governing member to add?',
    labelHeaderLevel: 'p',
    labels: {
      Y: 'Yes, I have a faculty member to add.',
      N: 'No, I do not have a faculty member to add.',
    },
    hint: '',
    errorMessages: {
      required: 'Select ‘yes’ if you have an official to add',
    },
  },
  {
    title:
      'Do you have an additional faculty member, school official, or governing member to add?',
    labelHeaderLevel: 'p',
    labels: {
      Y: 'Yes, I have a faculty member to add.',
      N: 'No, I do not have a faculty member to add.',
    },
    hint: '',
    errorMessages: {
      required: 'Select ‘yes’ if you have another official to add',
    },
  },
);

export default {
  uiSchema: {
    'view:hasAdditionalOfficials': {
      ...officialsSummaryYesNo,
      'ui:required': formData => hasOfficials(formData),
      'ui:options': {
        ...officialsSummaryYesNo['ui:options'],
        hideIf: formData => !hasOfficials(formData),
      },
    },
  },

  schema: {
    type: 'object',
    properties: {
      'view:hasAdditionalOfficials': arrayBuilderYesNoSchema,
    },
  },
};
